import {
  ActivityEventParameters,
  EntityDimensionType,
  Tag
} from 'features/dispatcher/dispatcherTypes';
import { MetaDataInterface } from 'models';

// ==============================|| MODELS ||============================== //

export enum AlarmsColumn {
  TRIGGERED_AT = 'triggeredAt',
  CODE = 'code',
  SEVERITY = 'severity',
  STATUS = 'status',
  PARAMETERS = 'parameters',
  TAGS = 'tags',
  MARKET_PARTICIPANT = 'marketParticipant',
  BALANCING_GROUP = 'balancingGroup',
  DELIVERY_POINT = 'deliveryPoint',
  DEVICE = 'device',
  ACTIONS = 'actions'
}

export enum AlarmSeverity {
  NOT_CLASSIFIED = 'NOT_CLASSIFIED',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL'
}

export enum AlarmStatus {
  TRIGGERED = 'TRIGGERED',
  RESOLVED = 'RESOLVED',
  CANCELLED = 'CANCELLED'
}

export type AlarmResolution = {
  resolvedAt: number;
  resolvedBy: string;
  resolutionNote: string;
};

export type AlarmDto = {
  alarmId: string;
  type: string;
  status: AlarmStatus;
  severity: AlarmSeverity;
  triggeredAt: string;
  triggeredBy: string;
  tags?: Tag[];
  parameters?: ActivityEventParameters[];
  resolution: AlarmResolution;
  device: EntityDimensionType;
  balancingGroup: EntityDimensionType;
  deliveryPoint: EntityDimensionType;
  marketParticipant: EntityDimensionType;
  meta: MetaDataInterface;
};

export type AlarmsTableRowActions = {
  alarmId: string;
  reason: AlarmResolution;
  status: AlarmStatus;
};

export type AlarmsTableRow = {
  id: string;
  [AlarmsColumn.TRIGGERED_AT]: string;
  [AlarmsColumn.CODE]: string;
  [AlarmsColumn.SEVERITY]: AlarmSeverity;
  [AlarmsColumn.STATUS]: {
    status: AlarmStatus;
    reason?: AlarmResolution;
  };
  [AlarmsColumn.PARAMETERS]: ActivityEventParameters[];
  [AlarmsColumn.TAGS]: Tag[];
  [AlarmsColumn.MARKET_PARTICIPANT]: EntityDimensionType;
  [AlarmsColumn.BALANCING_GROUP]: EntityDimensionType;
  [AlarmsColumn.DELIVERY_POINT]: EntityDimensionType;
  [AlarmsColumn.DEVICE]: EntityDimensionType;
  [AlarmsColumn.ACTIONS]: AlarmsTableRowActions;
};

export type UseAlarmsColumnsProps = {
  onCancel: (alarmId: string) => void;
  onResolve: (alarmId: string) => void;
};

export type AlarmActionType = 'resolve' | 'cancel';

export type AlarmsDialogStateType = {
  dialogType: AlarmActionType | null;
  alarmId: string | null;
};
